module.exports = __webpack_public_path__ + "img/9788952758958.7cc5b3e4.jpg";